var map = {
	"./album.vue": "iuKr",
	"./barrage.vue": "/OvZ",
	"./bless.vue": "ppeZ",
	"./lottery.vue": "IWfa",
	"./setting.vue": "xXdY",
	"./toast.vue": "AU0D",
	"./wait.vue": "YQny"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d/6I";


//////////////////
// WEBPACK FOOTER
// ./src/components nonrecursive \.vue$
// module id = d/6I
// module chunks = 1